import { Component, OnInit, AfterViewInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'pplus-table-edit-select',
  templateUrl: './pplus-table-edit-select.component.html',
  styleUrls: ['./pplus-table-edit-select.component.scss']
})
export class PplusTableEditSelectComponent implements ICellEditorAngularComp, AfterViewInit {
  private params: any;
  public value: number;
  private cancelBeforeStart = false;

  @ViewChild('input', { read: ViewContainerRef, static: false }) public input;

  agInit(params: any): void {
    this.params = params;
    this.value = this.params.value;
  }
  clear() {
    this.value = 0;
    return this.value;
  }

  getValue(): any {
    console.log(this.value);
    return this.value;
  }

  isPopup(){
    return false;
  }

  // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
  ngAfterViewInit() {
    window.setTimeout(() => {
      this.input.element.nativeElement.focus();
    });
  }
}
